//Node Modules
import React, { useRef } from "react";
import ChangeHighlight from "react-change-highlight";

//Pages

//BinaryForge Components

//3rd Party Components

//Atoms

//Helpers

//Other

const Field = ({ label, labelClass, response, responseUnit, responseClass = [], highlight }) => {
	//Stable ref: react-change-highlight reads child.ref.current without a null check, so a fresh
	//createRef() per render (replaced on re-commit) left a null current and crashed ShadowChild on edits.
	const responseRef = useRef(null);
	return highlight ? (
		<>
			<span className={`fontWeight-bold ${labelClass}`}>{label}:</span>
			<ChangeHighlight highlightClassName="highlight-onChange" containerClassName="field-value">
				<div ref={responseRef} className={`${responseClass.join(" ")}`}>
					{response}
					{responseUnit && (
						<span className="fontColour-lighter fontSize-small aSelf-end"> {responseUnit}</span>
					)}
				</div>
			</ChangeHighlight>
		</>
	) : (
		<>
			<span className={`fontWeight-bold ${labelClass}`}>{label}:</span>
			<div className="field-value">
				<div className={`${responseClass.join(" ")}`}>
					{response}
					{responseUnit && (
						<span className="fontColour-lighter fontSize-small aSelf-end"> {responseUnit}</span>
					)}
				</div>
			</div>
		</>
	);
};

export default Field;
